'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$159(ps$88) {
  this.a6V = null;
  this.a6V = ps$88;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$159 as $c_Lmealorama_jsonCodecs$package$$anon$159 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$159.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$159;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$159() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$159 as $h_Lmealorama_jsonCodecs$package$$anon$159 };
$h_Lmealorama_jsonCodecs$package$$anon$159.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6V.a.length;
});
$p.g = (function(i) {
  return this.a6V.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$159 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$159, "mealorama.jsonCodecs$package$$anon$159", ({
  Jb: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$159 as $d_Lmealorama_jsonCodecs$package$$anon$159 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$159.js.map
